import React from 'react';
import * as S from './styles';
import logoImg from '../../assets/CEDAPP-CRM.png';
import InputMask from '../../components/InputMask';
import Input from '../../components/Input';
import { Button } from '../../components/Button';
import { useSignInBusiness } from './use-signIn-business';

export function SignInBusiness() {
  const { handleSignIn, signInData, setSignInData } = useSignInBusiness();
  const [enableTyping, setEnableTyping] = React.useState(false);

  return (
    <S.Container>
      <S.Logo src={logoImg} alt="CEDAPP" />
      <div>
        <S.Title>Faça seu login</S.Title>
      </div>
      <S.Content>
        <div>
          <InputMask
            placeholder="CNPJ"
            mask="99.999.999/9999-99"
            value={signInData.cnpj}
            autoComplete="off"
            name="company-document"
            readOnly={!enableTyping}
            onFocus={() => setEnableTyping(true)}
            onChange={(event) =>
              setSignInData({ ...signInData, cnpj: event.target.value })
            }
          />
          <Input
            placeholder="Senha"
            type="password"
            value={signInData.password}
            autoComplete="new-password"
            name="company-access-key"
            readOnly={!enableTyping}
            onFocus={() => setEnableTyping(true)}
            onChange={(event) =>
              setSignInData({ ...signInData, password: event.target.value })
            }
          />
        </div>
        <Button onClick={handleSignIn}>Entrar</Button>
      </S.Content>
    </S.Container>
  );
}
